import { ConfigProvider } from 'antd';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import { theme } from './antConfig';
import { Loader } from './components/loader/Loader';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;

root.render(
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={<Loader />}>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
    </Suspense>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

<>
  <script
    src="https://unpkg.com/react/umd/react.production.min.js"
    crossOrigin></script>
  <script
    src="https://unpkg.com/react-dom/umd/react-dom.production.min.js"
    crossOrigin></script>
  <script
    src="https://unpkg.com/react-bootstrap@next/dist/react-bootstrap.min.js"
    crossOrigin></script>
  <script>var Alert = ReactBootstrap.Alert;</script>
</>;
